import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { SimpleGrid, Space, Text, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useIntl } from 'react-intl';

import { PageLoading } from '@/pages/PageLoading';
import { useArtistLanguages } from '@/pages/artist/onboard/components/stages/languages/hooks/useArtistLanguages.ts';
import { LANGUAGES_LIST } from '@/shared/data/languages';
import { translate } from '@/shared/i18n/translate';
import { LBModalFullscreenLayout } from '@/shared/layouts/modal/ModalFullScreenLayout';
import { ForeignLanguageItem } from '@/shared/modules';
import {
  LBButton,
  LBLinkButton,
  LBModalHeader,
  LBSelect
} from '@/shared/ui-kit/components';
import { ForeignLanguage } from '@/shared/view/foreign-language';

export const ArtistLanguages = () => {
  const { state, functions } = useArtistLanguages();
  const { formatMessage } = useIntl();
  const [opened, { open, close }] = useDisclosure();
  if (state.isLoading) return <PageLoading />;
  return (
    <div style={{ height: '100%' }}>
      <LBModalFullscreenLayout opened={opened} onClose={close}>
        <LBModalHeader onClose={close} />
        <ForeignLanguage
          initialValues={state.form.getValues().languages}
          onReturnSelectedValues={(value) => {
            state.form.setFieldValue('languages', value);
            close();
          }}
        />
      </LBModalFullscreenLayout>
      <form onSubmit={functions.onSubmit}>
        <Title order={1}>
          {translate('pages.onboarding.artist.language.title')}
        </Title>
        <Space h={32} />
        <LBSelect
          searchable
          data={LANGUAGES_LIST}
          disabled={state.form.submitting}
          label={formatMessage({ id: 'form.nativeLanguage.label' })}
          placeholder={formatMessage({ id: 'form.nativeLanguage.placeholder' })}
          value={state.form.getValues().native.name}
          onChange={(value) => {
            state.form.setFieldValue('native.name', value!);
          }}
        />
        <Space h={16} />
        <Text fz={14}>
          {translate('pages.onboarding.artist.language.languageProfinience')}
        </Text>
        <Space h={8} />
        <SimpleGrid cols={2} spacing='xs' verticalSpacing='xs'>
          {state.form.getValues().languages.map((item, index) => (
            <ForeignLanguageItem
              key={item.name}
              level={item.level}
              name={item.name}
              onRemove={() => functions.onRemoveItem(index)}
            />
          ))}
        </SimpleGrid>
        <Space h={8} />

        <LBLinkButton
          disabled={state.form.submitting}
          leftsection={<PlusCircleIcon width={18} />}
          type='button'
          onClick={open}
        >
          {translate('commons.add')}
        </LBLinkButton>
        <Space h={32} />
        <LBButton
          fullWidth
          bottom={60}
          disabled={!state.isValid}
          loading={state.form.submitting}
          pos='sticky'
          type='submit'
        >
          {translate('commons.save-and-continue')}
        </LBButton>
      </form>
    </div>
  );
};
